import { tabs } from '../../../../../../views/dashboard/service-provider';

export default {
  tabs: {
    [tabs.general]: 'General',
    [tabs.restaurant_details]: 'Detalii restaurant',
    [tabs.order_conversion]: 'Conversie comenzi',
    [tabs.external_delivery]: 'Livrare externă',
    [tabs.mobile_app]: 'Aplicație mobilă',
    [tabs.customer_success_team]: 'Echipa de succes clienți',
    [tabs.onboarding_team]: 'Echipa de onboarding',
  },
  date_range: {
    this_month: 'Luna aceasta',
    last_month: 'Luna trecută',
    last_week: 'Săptămâna trecută',
    last_year: 'Anul trecut',
    this_week: 'Săptămâna aceasta',
    this_year: 'Anul acesta',
    today: 'Astăzi',
    yesterday: 'Ieri',
    all: 'Toate',
  },
};
